import { Controller } from '@hotwired/stimulus'
import { createApp, type App as VueApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from '@/v2/pipeline6/queryClient'

export default class extends Controller<HTMLElement> {
  private app?: VueApp
  static values = { requisitionId: Number, pipelineUrl: String }

  declare requisitionIdValue: number
  declare pipelineUrlValue: string

  async connect (): Promise<void> {
    const { default: Tutorial } = await import('@/v2/tutorial/Tutorial.vue')
    if (!this.element.isConnected) return

    this.app = createApp(Tutorial, {
      requisitionId: this.requisitionIdValue,
      pipelineUrl: this.pipelineUrlValue,
    })
    this.app.use(createPinia())
    this.app.use(VueQueryPlugin, { queryClient })
    this.app.mount(this.element)
  }

  disconnect (): void {
    this.app?.unmount()
  }
}
